exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beauti-context[data-v-73ddcaae]{position:fixed;border-radius:5px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.15);box-shadow:0 5px 10px rgba(0,0,0,.15);background-color:#fff;opacity:.97;-webkit-transition:all .2s cubic-bezier(0,.5,0,1) 0s;transition:all .2s cubic-bezier(0,.5,0,1) 0s;-webkit-transform-origin:center top;transform-origin:center top}.beauti-context.beauti-context-enter[data-v-73ddcaae],.beauti-context.beauti-context-leave-to[data-v-73ddcaae]{opacity:0!important}.beauti-context.beauti-context-enter-active-to[data-v-73ddcaae]{opacity:.97!important}", ""]);

// exports
